import { render, staticRenderFns } from "./ThankYouModal.vue?vue&type=template&id=f5c854cc&scoped=true&"
import script from "./ThankYouModal.vue?vue&type=script&lang=js&"
export * from "./ThankYouModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c854cc",
  null
  
)

export default component.exports